import React, { FC, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { useActivation } from "../../../../../lib/hooks/useActivation";
import { Transition } from "react-transition-group";
import { imagePath } from "../image/util";
import styled, { css } from "styled-components";
import { AnswererBubble } from "./DialogueBubble";
import { Icon, Row } from "./DialogueRow";

const AnswererRow: FC<{ image: string }> = ({ image, children, ...props }) => {
  const [ref, inView] = useInView({ threshold: 0.2 });
  const [inViewFirstly, activateInView] = useActivation(false);
  useEffect(() => {
    if (inView) activateInView();
  }, [inView]);
  return (
    <Transition in={inViewFirstly} timeout={400}>
      {(state) => (
        <Root ref={ref} $status={state} {...props}>
          <Icon src={imagePath(image)} loading="lazy" />
          <StyledAnswererBubble>{children}</StyledAnswererBubble>
        </Root>
      )}
    </Transition>
  );
};
export default AnswererRow;

const Root = styled(Row)`
  flex-direction: row-reverse;
`;
const BubbleStyle = css`
  @media screen and (max-width: 960px) {
    width: 66vw;
    min-height: 16vw;
  }
  @media screen and (min-width: 601px) and (max-width: 960px) {
    width: 398px;
    min-height: 60px;
  }
  @media screen and (min-width: 961px) {
    width: 600px;
  }
  @media screen and (min-width: 1441px) and (max-width: 1920px) {
    width: 800px;
  }
  @media screen and (min-width: 1921px) {
    width: 800px;
  }
`;
const StyledAnswererBubble = styled(AnswererBubble)`
  ${BubbleStyle};
  color: #fff;
`;
